export const formatFt = value => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '0 Ft'
  const rounded = Math.round(numeric)
  return `${rounded.toLocaleString('hu-HU')} Ft`
}

export default formatFt
